

// import React, { useEffect, useState, useRef } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, setUser, setGoogleUser } from '../../../Commonlibs/userSlice';
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   TextareaAutosize,
//   CircularProgress,
//   Snackbar,
//   Alert,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Avatar
// } from '@mui/material';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import Loader from '../../../Loader/Loader';
// import ChangePassword from '../../../Authuntication/ChangePassword';
// import leftImage from '../../../assets/logip.png';

// const ProfileEdit = () => {
//   // Get user ID from Redux store
//   const user = useSelector(selectUser);
//   const dispatch = useDispatch();
//   const userId = user?.id;

//   // State for profile data
//   const [profileData, setProfileData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [saving, setSaving] = useState(false);

//   // States for edit mode
//   const [personalEditMode, setPersonalEditMode] = useState(false);
//   const [professionalEditMode, setProfessionalEditMode] = useState(false);
//   const [photoEditMode, setPhotoEditMode] = useState(false);

//   // State for file upload
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [previewUrl, setPreviewUrl] = useState(null);
//   const [originalPhotoUrl, setOriginalPhotoUrl] = useState(null);
//   const fileInputRef = useRef(null);

//   // State for change password dialog
//   const [changePasswordOpen, setChangePasswordOpen] = useState(false);

//   // State for validation errors
//   const [validationErrors, setValidationErrors] = useState({});

//   // State for snackbar
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: '',
//     severity: 'info'
//   });

//   // Handle snackbar close
//   const handleCloseSnackbar = () => {
//     setSnackbar({...snackbar, open: false});
//   };

//   // Show snackbar message
//   const showSnackbar = (message, severity = 'info') => {
//     setSnackbar({
//       open: true,
//       message,
//       severity
//     });
//   };

//   // Fetch user profile data
//   useEffect(() => {
//     const fetchUserProfile = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`);
//         const data = await response.json();

//         if (data.status === "SUCCESS") {
//           setProfileData(data.result);
//           if (data.result.profile_image) {
//             setPreviewUrl(data.result.profile_image);
//             setOriginalPhotoUrl(data.result.profile_image);
//           }
//         } else {
//           setError(data.message || 'Failed to fetch profile data');
//         }
//       } catch (err) {
//         setError('Error fetching profile data. Please try again later.');
//         console.error('Error fetching profile:', err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (userId) {
//       fetchUserProfile();
//     }
//   }, [userId]);

//   // Validate a field based on its name and value
//   const validateField = (name, value) => {
//     // Skip validation if the field is empty (fields are optional)
//     if (!value || value.trim() === '') {
//       return '';
//     }

//     switch (name) {
//       case 'full_name':
//         return /^[A-Za-z\s]{2,50}$/.test(value)
//           ? ''
//           : 'Name should contain only letters and spaces (2-50 characters)';
//       case 'email_id':
//         return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
//           ? ''
//           : 'Please enter a valid email address';
//       case 'contact_number':
//         return /^\d{10}$/.test(value)
//           ? ''
//           : 'Phone number should be 10 digits';
//       case 'years_of_experience':
//         return /^\d{1,2}$/.test(value) && parseInt(value) <= 99
//           ? ''
//           : 'Experience should be a number between 0-99';
//       case 'website':
//         if (value) {
//           return /^(https?:\/\/)?(www\.)?[a-zA-Z0-9@:%.\_+\~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%\_+.\~#?&//=]*)$/.test(value)
//             ? ''
//             : 'Please enter a valid website URL';
//         }
//         return '';
//       case 'linkedin':
//       case 'facebook':
//         if (value) {
//           return /^(https?:\/\/)?(www\.)?(linkedin\.com|facebook\.com)\/[a-zA-Z0-9\-.\\_\~:\/?#\[\]@!$&'()\*+,;=]{2,}$/.test(value)
//             ? ''
//             : `Please enter a valid ${name === 'linkedin' ? 'LinkedIn' : 'Facebook'} profile URL`;
//         }
//         return '';
//       default:
//         return '';
//     }
//   };

//   // Handle form field changes with validation
//   const handleChange = (field, value) => {
//     setProfileData(prev => ({
//       ...prev,
//       [field]: value
//     }));

//     // Validate the field
//     const error = validateField(field, value);
//     // Update validation errors
//     setValidationErrors(prev => ({
//       ...prev,
//       [field]: error
//     }));
//   };

//   // Toggle edit modes
//   const togglePersonalEditMode = () => {
//     if (personalEditMode) {
//       // Reset validation errors when canceling
//       const newErrors = { ...validationErrors };
//       ['full_name', 'email_id', 'contact_number', 'location', 'occupation'].forEach(field => {
//         delete newErrors[field];
//       });
//       setValidationErrors(newErrors);

//       // Refetch profile data to reset changes
//       if (userId) {
//         fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`)
//           .then(response => response.json())
//           .then(data => {
//             if (data.status === "SUCCESS") {
//               setProfileData(data.result);
//             }
//           })
//           .catch(err => {
//             console.error('Error refetching profile:', err);
//           });
//       }
//     }
//     setPersonalEditMode(!personalEditMode);
//   };

//   const toggleProfessionalEditMode = () => {
//     if (professionalEditMode) {
//       // Reset validation errors when canceling
//       const newErrors = { ...validationErrors };
//       ['professional_title', 'company_name', 'years_of_experience', 'license_number', 'bio', 'website', 'linkedin', 'facebook'].forEach(field => {
//         delete newErrors[field];
//       });
//       setValidationErrors(newErrors);

//       // Refetch profile data to reset changes
//       if (userId) {
//         fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`)
//           .then(response => response.json())
//           .then(data => {
//             if (data.status === "SUCCESS") {
//               setProfileData(data.result);
//             }
//           })
//           .catch(err => {
//             console.error('Error refetching profile:', err);
//           });
//       }
//     }
//     setProfessionalEditMode(!professionalEditMode);
//   };

//   // Toggle photo edit mode
//   const togglePhotoEditMode = () => {
//     if (photoEditMode) {
//       // Cancel: Reset to original photo
//       setPreviewUrl(originalPhotoUrl);
//       setSelectedFile(null);
//       if (fileInputRef.current) {
//         fileInputRef.current.value = '';
//       }
//     }
//     setPhotoEditMode(!photoEditMode);
//   };

//   const handleFileChange = (event) => {
//     // Get the first file from the FileList
//     const file = event.target.files[0];
//     if (file) {
//       // Validate file size (5MB limit)
//       if (file.size > 5 * 1024 * 1024) {
//         showSnackbar('Profile image exceeds 5MB limit', 'error');
//         return;
//       }

//       // Validate file type
//       if (!file.type.match('image.*')) {
//         showSnackbar('Please select a valid image for your profile', 'error');
//         return;
//       }

//       setSelectedFile(file);
//       // Create preview URL
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewUrl(reader.result);
//       };
//       reader.readAsDataURL(file);

//       // Clear input value to allow re-selecting the same file
//       event.target.value = '';
//     }
//   };

//   // Trigger file input click
//   const handlePhotoButtonClick = () => {
//     fileInputRef.current.click();
//   };

//   // Handle change password dialog
//   const handleOpenChangePassword = () => {
//     setChangePasswordOpen(true);
//   };

//   const handleCloseChangePassword = () => {
//     setChangePasswordOpen(false);
//   };

//   // Validate all fields before saving
//   const validateAllFields = () => {
//     const errors = {};
//     let isValid = true;

//     // Only validate fields that have values (since fields are optional)
//     Object.entries(profileData || {}).forEach(([key, value]) => {
//       if (value && typeof value === 'string' && value.trim() !== '') {
//         const error = validateField(key, value);
//         if (error) {
//           errors[key] = error;
//           isValid = false;
//         }
//       }
//     });

//     setValidationErrors(errors);
//     return isValid;
//   };

//   // Handle save photo changes
//   const handleSavePhotoChanges = async () => {
//     if (!selectedFile) {
//       showSnackbar('Please select a photo to upload', 'warning');
//       return;
//     }

//     try {
//       setSaving(true);
//       const formData = new FormData();
//       formData.append('user_id', userId);
//       formData.append('full_name', profileData?.full_name || '');
//       formData.append('email_id', profileData?.email_id || '');
//       formData.append('contact_number', profileData?.contact_number || '');
//       formData.append('location', profileData?.location || '');
//       formData.append('occupation', profileData?.occupation || '');
//       formData.append('professional_title', profileData?.professional_title || '');
//       formData.append('company_name', profileData?.company_name || '');
//       formData.append('years_of_experience', profileData?.years_of_experience || '');
//       formData.append('license_number', profileData?.license_number || '');
//       formData.append('bio', profileData?.bio || '');
//       formData.append('website', profileData?.website || '');
//       formData.append('linkedin', profileData?.linkedin || '');
//       formData.append('facebook', profileData?.facebook || '');
//       formData.append('profile_image', selectedFile);

//       const response = await fetch('https://www.propertydealstalk.com/api/users/UpdateUserprofile', {
//         method: 'POST',
//         body: formData,
//       });

//       const data = await response.json();

//       if (data.status === "SUCCESS") {
//         showSnackbar('Profile photo updated successfully', 'success');
//         setProfileData(data.result);
        
//         if (data.result.profile_image) {
//           setPreviewUrl(data.result.profile_image);
//           setOriginalPhotoUrl(data.result.profile_image);
          
//           // Update Redux state with new profile image
//           const updatedUser = {
//             ...user,
//             profileImage: data.result.profile_image,
//             fullName: data.result.full_name,
//             email: data.result.email_id,
//             contactNumber: data.result.contact_number,
//             location: data.result.location,
//             occupation: data.result.occupation,
//             professionalTitle: data.result.professional_title,
//             companyName: data.result.company_name,
//             yearsOfExperience: data.result.years_of_experience,
//             licenseNumber: data.result.license_number,
//             bio: data.result.bio,
//             website: data.result.website,
//             linkedin: data.result.linkedin,
//             facebook: data.result.facebook,
//           };

//           if (data.result.auth_provider === 'google') {
//             dispatch(setGoogleUser(updatedUser));
//           } else {
//             dispatch(setUser(updatedUser));
//           }
//         }

//         // ✅ Trigger navbar refresh
//         localStorage.setItem('profile_updated', 'true');

//         setPhotoEditMode(false);
//         setSelectedFile(null);
//       } else {
//         showSnackbar(data.message || 'Failed to update profile photo', 'error');
//       }
//     } catch (err) {
//       console.error('Error updating profile photo:', err);
//       showSnackbar('Error updating profile photo. Please try again later.', 'error');
//     } finally {
//       setSaving(false);
//     }
//   };

//   // Handle save changes for personal information
//   const handleSavePersonalChanges = async () => {
//     // Validate all fields before saving
//     if (!validateAllFields()) {
//       showSnackbar('Please correct the validation errors before saving', 'error');
//       return;
//     }

//     try {
//       setSaving(true);
//       // Create FormData for file upload
//       const formData = new FormData();

//       // Add user_id
//       formData.append('user_id', userId);

//       // Add all required profile data fields to FormData
//       formData.append('full_name', profileData?.full_name || '');
//       formData.append('email_id', profileData?.email_id || '');
//       formData.append('contact_number', profileData?.contact_number || '');
//       formData.append('location', profileData?.location || '');
//       formData.append('occupation', profileData?.occupation || '');
//       formData.append('professional_title', profileData?.professional_title || '');
//       formData.append('company_name', profileData?.company_name || '');
//       formData.append('years_of_experience', profileData?.years_of_experience || '');
//       formData.append('license_number', profileData?.license_number || '');
//       formData.append('bio', profileData?.bio || '');
//       formData.append('website', profileData?.website || '');
//       formData.append('linkedin', profileData?.linkedin || '');
//       formData.append('facebook', profileData?.facebook || '');

//       // Add profile image if selected
//       if (selectedFile) {
//         formData.append('profile_image', selectedFile);
//       }

//       const response = await fetch('https://www.propertydealstalk.com/api/users/UpdateUserprofile', {
//         method: 'POST',
//         body: formData,
//       });

//       const data = await response.json();
//       console.log('Profile update response:', data);

//       if (data.status === "SUCCESS") {
//         showSnackbar('Profile updated successfully', 'success');
//         // Update the profile data with the response result
//         setProfileData(data.result);

//         // Update preview URL if there's a profile image in the response
//         if (data.result.profile_image) {
//           setPreviewUrl(data.result.profile_image);
//         }

//         // Update Redux state
//         const updatedUser = {
//           ...user,
//           fullName: data.result.full_name,
//           email: data.result.email_id,
//           contactNumber: data.result.contact_number,
//           profileImage: data.result.profile_image,
//           location: data.result.location,
//           occupation: data.result.occupation,
//         };

//         if (data.result.auth_provider === 'google') {
//           dispatch(setGoogleUser(updatedUser));
//         } else {
//           dispatch(setUser(updatedUser));
//         }

//         // ✅ Trigger navbar refresh
//         localStorage.setItem('profile_updated', 'true');

//         // Reset edit mode
//         setPersonalEditMode(false);
//         // Reset selected file after successful upload
//         setSelectedFile(null);
//         // Reset validation errors
//         setValidationErrors({});
//       } else {
//         showSnackbar(data.message || 'Failed to update profile', 'error');
//       }
//     } catch (err) {
//       console.error('Error updating profile:', err);
//       showSnackbar('Error updating profile. Please try again later.', 'error');
//     } finally {
//       setSaving(false);
//     }
//   };

//   // Handle save changes for professional information
//   const handleSaveProfessionalChanges = async () => {
//     // Validate all fields before saving
//     if (!validateAllFields()) {
//       showSnackbar('Please correct the validation errors before saving', 'error');
//       return;
//     }

//     try {
//       setSaving(true);
//       // Create FormData for file upload
//       const formData = new FormData();

//       // Add user_id
//       formData.append('user_id', userId);

//       // Add all required profile data fields to FormData
//       formData.append('full_name', profileData?.full_name || '');
//       formData.append('email_id', profileData?.email_id || '');
//       formData.append('contact_number', profileData?.contact_number || '');
//       formData.append('location', profileData?.location || '');
//       formData.append('occupation', profileData?.occupation || '');
//       formData.append('professional_title', profileData?.professional_title || '');
//       formData.append('company_name', profileData?.company_name || '');
//       formData.append('years_of_experience', profileData?.years_of_experience || '');
//       formData.append('license_number', profileData?.license_number || '');
//       formData.append('bio', profileData?.bio || '');
//       formData.append('website', profileData?.website || '');
//       formData.append('linkedin', profileData?.linkedin || '');
//       formData.append('facebook', profileData?.facebook || '');

//       // Add profile image if selected
//       if (selectedFile) {
//         formData.append('profile_image', selectedFile);
//       }

//       const response = await fetch('https://www.propertydealstalk.com/api/users/UpdateUserprofile', {
//         method: 'POST',
//         body: formData,
//       });

//       const data = await response.json();
//       console.log('Profile update response:', data);

//       if (data.status === "SUCCESS") {
//         showSnackbar('Profile updated successfully', 'success');
//         // Update the profile data with the response result
//         setProfileData(data.result);

//         // Update preview URL if there's a profile image in the response
//         if (data.result.profile_image) {
//           setPreviewUrl(data.result.profile_image);
//         }

//         // Update Redux state
//         const updatedUser = {
//           ...user,
//           professionalTitle: data.result.professional_title,
//           companyName: data.result.company_name,
//           yearsOfExperience: data.result.years_of_experience,
//           licenseNumber: data.result.license_number,
//           bio: data.result.bio,
//           website: data.result.website,
//           linkedin: data.result.linkedin,
//           facebook: data.result.facebook,
//           profileImage: data.result.profile_image,
//         };

//         if (data.result.auth_provider === 'google') {
//           dispatch(setGoogleUser(updatedUser));
//         } else {
//           dispatch(setUser(updatedUser));
//         }

//         // ✅ Trigger navbar refresh
//         localStorage.setItem('profile_updated', 'true');

//         // Reset edit mode
//         setProfessionalEditMode(false);
//         // Reset selected file after successful upload
//         setSelectedFile(null);
//         // Reset validation errors
//         setValidationErrors({});
//       } else {
//         showSnackbar(data.message || 'Failed to update profile', 'error');
//       }
//     } catch (err) {
//       console.error('Error updating profile:', err);
//       showSnackbar('Error updating profile. Please try again later.', 'error');
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (loading) {
//     return <Loader />;
//   }

//   if (error) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
//         <Typography color="error">{error}</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box
//       sx={{
//         flex: 1,
//         mt: { xs: '10px', md: '25px' },
//         mr: { md: '80px' },
//         mb: '20px',
//         background: '#fff',
//         p: { xs: '15px', md: '40px 50px' },
//         borderRadius: '16px',
//         width: { xs: 'calc(100% - 30px)', md: 'auto' },
//         mx: { xs: 'auto', md: 0 }
//       }}
//     >
//       {saving && <Loader />}

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//       <Typography
//         variant="h2"
//         sx={{
//           fontSize: '24px',
//           fontWeight: 600,
//           mb: '4px',
//         }}
//       >
//         Edit Profile
//       </Typography>

//       <Typography
//         sx={{
//           fontSize: '14px',
//           color: '#555',
//           mb: '24px',
//         }}
//       >
//         Update your personal information and preferences
//       </Typography>

//       {/* Photo Section with Save/Cancel Buttons */}
//       <Box sx={{
//         display: 'flex',
//         alignItems: 'center',
//         mb: '40px',
//         flexDirection: { xs: 'column', sm: 'row' },
//         justifyContent: 'space-between'
//       }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: { xs: 'column', sm: 'row' } }}>
//           {previewUrl || profileData?.profile_image ? (
//             <Box
//               component="img"
//               src={previewUrl || profileData?.profile_image}
//               alt="Profile"
//               sx={{
//                 width: '100px',
//                 height: '100px',
//                 borderRadius: '50%',
//                 objectFit: 'cover',
//                 mb: { xs: 2, sm: 0 }
//               }}
//               onError={(e) => {
//                 e.target.style.display = 'none';
//                 e.target.nextSibling.style.display = 'block';
//               }}
//             />
//           ) : (
//             <AccountCircleIcon
//               sx={{
//                 width: '100px',
//                 height: '100px',
//                 color: '#9CA3AF',
//                 mb: { xs: 2, sm: 0 }
//               }}
//             />
//           )}

//           <Box sx={{
//             ml: { xs: 0, sm: '20px' },
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: { xs: 'center', sm: 'flex-start' }
//           }}>
//             <input
//               type="file"
//               accept="image/*"
//               ref={fileInputRef}
//               style={{ display: 'none' }}
//               onChange={handleFileChange}
//               disabled={!photoEditMode}
//             />
//             <Button
//               variant="contained"
//               onClick={handlePhotoButtonClick}
//               disabled={saving || !photoEditMode}
//               sx={{
//                 background: photoEditMode ? '#0066ff' : '#cccccc',
//                 color: '#fff',
//                 px: '12px',
//                 py: '6px',
//                 borderRadius: '6px',
//                 fontSize: '12px',
//                 display: 'block',
//                 '&:hover': { background: photoEditMode ? '#0055cc' : '#cccccc' },
//                 '&.Mui-disabled': {
//                   background: '#cccccc',
//                   color: '#666666',
//                 },
//               }}
//             >
//               {saving ? 'Uploading...' : 'Change Photo'}
//             </Button>
//             <Typography
//               sx={{
//                 fontSize: '12px',
//                 color: '#666',
//                 mt: '4px',
//                 textAlign: { xs: 'center', sm: 'left' }
//               }}
//             >
//               JPG, PNG (max 5MB)
//             </Typography>
//           </Box>
//         </Box>

//         {/* Save/Cancel Buttons for Photo */}
//         <Box sx={{ display: 'flex', gap: '12px', mt: { xs: 2, sm: 0 } }}>
//           {photoEditMode && (
//             <Button
//               variant="contained"
//               onClick={handleSavePhotoChanges}
//               disabled={saving || !selectedFile}
//               sx={{
//                 background: '#0066ff',
//                 color: '#fff',
//                 px: '12px',
//                 py: '6px',
//                 borderRadius: '6px',
//                 fontSize: '12px',
//                 '&:hover': { background: '#0055cc' },
//                 '&.Mui-disabled': {
//                   background: '#cccccc',
//                   color: '#666666',
//                 },
//               }}
//             >
//               Save Changes
//             </Button>
//           )}
//           <Button
//             variant="contained"
//             onClick={togglePhotoEditMode}
//             sx={{
//               background: '#0066ff',
//               color: '#fff',
//               px: '12px',
//               py: '6px',
//               borderRadius: '6px',
//               fontSize: '12px',
//               '&:hover': { background: '#0055cc' },
//             }}
//           >
//             {photoEditMode ? 'Cancel' : 'Edit photo'}
//           </Button>
//         </Box>
//       </Box>

//       {/* PERSONAL INFORMATION */}
//       <Box
//         sx={{
//           background: '#fff',
//           p: { xs: '15px', md: '24px 20px' },
//           borderRadius: '12px',
//           mb: '30px',
//           boxShadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
//           ml: { md: '120px' },
//           border: '1px solid #E5E7EB',
//           width: { xs: '100%', md: 'auto' },
//           boxSizing: 'border-box'
//         }}
//       >
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: { xs: 'flex-start', sm: 'center' },
//             mb: '20px',
//             flexDirection: { xs: 'column', sm: 'row' },
//             gap: { xs: 2, sm: 0 }
//           }}
//         >
//           <Typography sx={{ fontSize: '16px', m: 0 }}>Personal Information</Typography>
//           <Box sx={{ display: 'flex', gap: '12px' }}>
//             {personalEditMode && (
//               <Button
//                 variant="contained"
//                 onClick={handleSavePersonalChanges}
//                 disabled={saving}
//                 sx={{
//                   background: '#0066ff',
//                   color: '#fff',
//                   px: '12px',
//                   py: '6px',
//                   borderRadius: '6px',
//                   fontSize: '12px',
//                   '&:hover': { background: '#0055cc' },
//                   '&.Mui-disabled': {
//                     background: '#cccccc',
//                     color: '#666666',
//                   },
//                 }}
//               >
//                 Save Changes
//               </Button>
//             )}
//             <Button
//               variant="contained"
//               onClick={togglePersonalEditMode}
//               sx={{
//                 background: '#0066ff',
//                 color: '#fff',
//                 px: '12px',
//                 py: '6px',
//                 borderRadius: '6px',
//                 fontSize: '12px',
//                 '&:hover': { background: '#0055cc' },
//               }}
//             >
//               {personalEditMode ? 'Cancel' : 'Edit Details'}
//             </Button>
//           </Box>
//         </Box>

//         <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
//           <Box
//             sx={{
//               display: 'flex',
//               gap: { xs: '15px', md: '70px' },
//               flexDirection: { xs: 'column', md: 'row' },
//             }}
//           >
//             <FormGroup
//               label="Full Name"
//               type="text"
//               value={profileData?.full_name || ''}
//               onChange={(e) => handleChange('full_name', e.target.value)}
//               disabled={!personalEditMode}
//               error={validationErrors.full_name}
//             />
//             <FormGroup
//               label="Email"
//               type="email"
//               value={profileData?.email_id || ''}
//               onChange={(e) => handleChange('email_id', e.target.value)}
//               disabled={!personalEditMode}
//               error={validationErrors.email_id}
//             />
//           </Box>

//           <Box
//             sx={{
//               display: 'flex',
//               gap: { xs: '15px', md: '70px' },
//               flexDirection: { xs: 'column', md: 'row' },
//             }}
//           >
//             <FormGroup
//               label="Phone Number"
//               type="text"
//               value={profileData?.contact_number || ''}
//               onChange={(e) => handleChange('contact_number', e.target.value)}
//               disabled={!personalEditMode}
//               error={validationErrors.contact_number}
//             />
//             <FormGroup
//               label="Location"
//               type="text"
//               value={profileData?.location || ''}
//               onChange={(e) => handleChange('location', e.target.value)}
//               disabled={!personalEditMode}
//               error={validationErrors.location}
//             />
//           </Box>

//           <Box
//             sx={{
//               display: 'flex',
//               gap: { xs: '15px', md: '70px' },
//               flexDirection: { xs: 'column', md: 'row' },
//             }}
//           >
//             <FormGroup
//               label="Occupation"
//               type="text"
//               value={profileData?.occupation || ''}
//               onChange={(e) => handleChange('occupation', e.target.value)}
//               disabled={!personalEditMode}
//               error={validationErrors.occupation}
//             />
//           </Box>

//           <Box
//             sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               maxWidth: 'none',
//               width: '100%',
//             }}
//           >
//             <Typography sx={{ fontSize: '12px', mb: '6px', color: '#333' }}>
//               Password
//             </Typography>
//             <Box
//               sx={{
//                 position: 'relative',
//                 display: 'flex',
//                 alignItems: 'center',
//                 width: { xs: '100%', md: '45%' },
//               }}
//             >
//               <TextField
//                 type="password"
//                 size="small"
//                 fullWidth
//                 disabled={!personalEditMode}
//                 value="********"
//                 sx={{
//                   '& input': {
//                     p: '10px 12px',
//                     backgroundColor: '#F9FAFB',
//                   },
//                   '& fieldset': {
//                     borderRadius: '6px',
//                     borderColor: '#ddd',
//                   },
//                 }}
//               />
//               <Button
//                 sx={{
//                   position: 'absolute',
//                   right: '10px',
//                   background: 'transparent',
//                   color: '#0066ff',
//                   fontSize: '12px',
//                   minWidth: 'auto',
//                   p: 0,
//                   '&:hover': { background: 'transparent' },
//                 }}
//                 disabled={!personalEditMode}
//                 onClick={handleOpenChangePassword}
//               >
//                 Change
//               </Button>
//             </Box>
//           </Box>
//         </Box>
//       </Box>

//       {/* PROFESSIONAL INFORMATION */}
//       <Box
//         sx={{
//           background: '#fff',
//           p: { xs: '15px', md: '24px 20px' },
//           borderRadius: '12px',
//           mb: '30px',
//           boxShadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
//           ml: { md: '120px' },
//           border: '1px solid #E5E7EB',
//           width: { xs: '100%', md: 'auto' },
//           boxSizing: 'border-box'
//         }}
//       >
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: { xs: 'flex-start', sm: 'center' },
//             flexDirection: { xs: 'column', sm: 'row' },
//             mb: '20px',
//             gap: { xs: 2, sm: 0 }
//           }}
//         >
//           <Typography sx={{ fontSize: '16px', m: 0 }}>Professional Information</Typography>
//           <Box sx={{ display: 'flex', gap: '12px' }}>
//             {professionalEditMode && (
//               <Button
//                 variant="contained"
//                 onClick={handleSaveProfessionalChanges}
//                 disabled={saving}
//                 sx={{
//                   background: '#0066ff',
//                   color: '#fff',
//                   px: '12px',
//                   py: '6px',
//                   borderRadius: '6px',
//                   fontSize: '12px',
//                   '&:hover': { background: '#0055cc' },
//                   '&.Mui-disabled': {
//                     background: '#cccccc',
//                     color: '#666666',
//                   },
//                 }}
//               >
//                 Save Changes
//               </Button>
//             )}
//             <Button
//               variant="contained"
//               onClick={toggleProfessionalEditMode}
//               sx={{
//                 background: '#0066ff',
//                 color: '#fff',
//                 px: '12px',
//                 py: '6px',
//                 borderRadius: '6px',
//                 fontSize: '12px',
//                 '&:hover': { background: '#0055cc' },
//               }}
//             >
//               {professionalEditMode ? 'Cancel' : 'Edit Details'}
//             </Button>
//           </Box>
//         </Box>

//         <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
//           <Box
//             sx={{
//               display: 'flex',
//               gap: { xs: '15px', md: '70px' },
//               flexDirection: { xs: 'column', md: 'row' },
//             }}
//           >
//             <FormGroup
//               label="Professional Title"
//               type="text"
//               value={profileData?.professional_title || ''}
//               onChange={(e) => handleChange('professional_title', e.target.value)}
//               disabled={!professionalEditMode}
//               error={validationErrors.professional_title}
//             />
//             <FormGroup
//               label="Company Name"
//               type="text"
//               value={profileData?.company_name || ''}
//               onChange={(e) => handleChange('company_name', e.target.value)}
//               disabled={!professionalEditMode}
//               error={validationErrors.company_name}
//             />
//           </Box>

//           <Box
//             sx={{
//               display: 'flex',
//               gap: { xs: '15px', md: '70px' },
//               flexDirection: { xs: 'column', md: 'row' },
//             }}
//           >
//             <FormGroup
//               label="Years of Experience"
//               type="text"
//               value={profileData?.years_of_experience || ''}
//               onChange={(e) => handleChange('years_of_experience', e.target.value)}
//               disabled={!professionalEditMode}
//               error={validationErrors.years_of_experience}
//             />
//             <FormGroup
//               label="License Number"
//               type="text"
//               value={profileData?.license_number || ''}
//               onChange={(e) => handleChange('license_number', e.target.value)}
//               disabled={!professionalEditMode}
//               error={validationErrors.license_number}
//             />
//           </Box>

//           <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
//             <Typography sx={{ fontSize: '12px', mb: '6px', color: '#333' }}>
//               Bio
//             </Typography>
//             <TextareaAutosize
//               minRows={4}
//               value={profileData?.bio || ''}
//               onChange={(e) => handleChange('bio', e.target.value)}
//               disabled={!professionalEditMode}
//               style={{
//                 padding: '10px 12px',
//                 border: '1px solid #ddd',
//                 borderRadius: '6px',
//                 fontSize: '14px',
//                 width: '95%',
//                 backgroundColor: professionalEditMode ? '#F9FAFB' : '#f5f5f5',
//               }}
//             />
//             {validationErrors.bio && (
//               <Typography color="error" sx={{ fontSize: '11px', mt: '4px' }}>
//                 {validationErrors.bio}
//               </Typography>
//             )}
//           </Box>

//           <FormGroup
//             label="Website"
//             type="text"
//             value={profileData?.website || ''}
//             onChange={(e) => handleChange('website', e.target.value)}
//             fullWidth
//             disabled={!professionalEditMode}
//             error={validationErrors.website}
//           />

//           <Box
//             sx={{
//               display: 'flex',
//               gap: { xs: '15px', md: '70px' },
//               flexDirection: { xs: 'column', md: 'row' },
//             }}
//           >
//             <FormGroup
//               label="LinkedIn"
//               type="text"
//               value={profileData?.linkedin || ''}
//               onChange={(e) => handleChange('linkedin', e.target.value)}
//               disabled={!professionalEditMode}
//               error={validationErrors.linkedin}
//             />
//             <FormGroup
//               label="Facebook"
//               type="text"
//               value={profileData?.facebook || ''}
//               onChange={(e) => handleChange('facebook', e.target.value)}
//               disabled={!professionalEditMode}
//               error={validationErrors.facebook}
//             />
//           </Box>
//         </Box>
//       </Box>

//       {/* Change Password Dialog */}
//       <ChangePassword
//         open={changePasswordOpen}
//         onClose={handleCloseChangePassword}
//       />
//     </Box>
//   );
// };

// // FormGroup component to handle value and onChange with error display
// const FormGroup = ({ label, type, fullWidth = false, value, onChange, disabled = false, error }) => (
//   <Box sx={{
//     flex: 1,
//     display: 'flex',
//     flexDirection: 'column',
//     maxWidth: fullWidth ? 'none' : { xs: 'none', md: '350px' },
//     width: fullWidth ? '100%' : 'auto'
//   }}>
//     <Typography sx={{ fontSize: '12px', mb: '6px', color: '#333' }}>
//       {label}
//     </Typography>
//     <TextField
//       type={type}
//       size="small"
//       fullWidth
//       value={value}
//       onChange={onChange}
//       disabled={disabled}
//       error={Boolean(error)}
//       sx={{
//         '& input': {
//           p: '10px 12px',
//           backgroundColor: disabled ? '#f5f5f5' : '#F9FAFB',
//         },
//         '& fieldset': {
//           borderRadius: '6px',
//           borderColor: error ? 'red' : '#ddd',
//         },
//       }}
//     />
//     {error && (
//       <Typography color="error" sx={{ fontSize: '11px', mt: '4px' }}>
//         {error}
//       </Typography>
//     )}
//   </Box>
// );

// export default ProfileEdit;




import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, setUser, setGoogleUser } from '../../../Commonlibs/userSlice';
import {
  Box,
  Typography,
  Button,
  TextField,
  TextareaAutosize,
  CircularProgress,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Avatar
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Loader from '../../../Loader/Loader';
import ChangePassword from '../../../Authuntication/ChangePassword';
import leftImage from '../../../assets/logip.png';

const ProfileEdit = () => {
  // Get user ID from Redux store
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const userId = user?.id;

  // State for profile data
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  // States for edit mode
  const [personalEditMode, setPersonalEditMode] = useState(false);
  const [professionalEditMode, setProfessionalEditMode] = useState(false);
  const [photoEditMode, setPhotoEditMode] = useState(false);

  // State for file upload
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [originalPhotoUrl, setOriginalPhotoUrl] = useState(null);
  const fileInputRef = useRef(null);

  // State for change password dialog
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  // State for validation errors
  const [validationErrors, setValidationErrors] = useState({});

  // State for snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info'
  });

  // ✅ Function to get user-friendly error message
  const getUserFriendlyErrorMessage = (error) => {
    const errorString = error.toString().toLowerCase();
    
    if (errorString.includes('fetch') || 
        errorString.includes('network') || 
        errorString.includes('failed to fetch') ||
        errorString.includes('networkerror') ||
        errorString.includes('connection')) {
      return 'Unable to load your profile. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('timeout')) {
      return 'Unable to load your profile. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('500') || errorString.includes('server error')) {
      return 'Unable to load your profile. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('404') || errorString.includes('not found')) {
      return 'Unable to load your profile. Please check your internet connection and try again.';
    }
    
    return 'Unable to load your profile. Please check your internet connection and try again.';
  };

  // Handle snackbar close
  const handleCloseSnackbar = () => {
    setSnackbar({...snackbar, open: false});
  };

  // Show snackbar message
  const showSnackbar = (message, severity = 'info') => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  };

  // ✅ Updated Fetch user profile data with improved error handling
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();

        if (data.status === "SUCCESS") {
          setProfileData(data.result);
          if (data.result.profile_image) {
            setPreviewUrl(data.result.profile_image);
            setOriginalPhotoUrl(data.result.profile_image);
          }
        } else {
          throw new Error('Failed to load profile');
        }
      } catch (err) {
        console.error('Error fetching profile:', err);
        const friendlyMessage = getUserFriendlyErrorMessage(err);
        setError(friendlyMessage);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchUserProfile();
    }
  }, [userId]);

  // Validate a field based on its name and value
  const validateField = (name, value) => {
    // Skip validation if the field is empty (fields are optional)
    if (!value || value.trim() === '') {
      return '';
    }

    switch (name) {
      case 'full_name':
        return /^[A-Za-z\s]{2,50}$/.test(value)
          ? ''
          : 'Name should contain only letters and spaces (2-50 characters)';
      case 'email_id':
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ''
          : 'Please enter a valid email address';
      case 'contact_number':
        return /^\d{10}$/.test(value)
          ? ''
          : 'Phone number should be 10 digits';
      case 'years_of_experience':
        return /^\d{1,2}$/.test(value) && parseInt(value) <= 99
          ? ''
          : 'Experience should be a number between 0-99';
      case 'website':
        if (value) {
          return /^(https?:\/\/)?(www\.)?[a-zA-Z0-9@:%.\_+\~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%\_+.\~#?&//=]*)$/.test(value)
            ? ''
            : 'Please enter a valid website URL';
        }
        return '';
      case 'linkedin':
      case 'facebook':
        if (value) {
          return /^(https?:\/\/)?(www\.)?(linkedin\.com|facebook\.com)\/[a-zA-Z0-9\-.\\_\~:\/?#\[\]@!$&'()\*+,;=]{2,}$/.test(value)
            ? ''
            : `Please enter a valid ${name === 'linkedin' ? 'LinkedIn' : 'Facebook'} profile URL`;
        }
        return '';
      default:
        return '';
    }
  };

  // Handle form field changes with validation
  const handleChange = (field, value) => {
    setProfileData(prev => ({
      ...prev,
      [field]: value
    }));

    // Validate the field
    const error = validateField(field, value);
    // Update validation errors
    setValidationErrors(prev => ({
      ...prev,
      [field]: error
    }));
  };

  // Toggle edit modes
  const togglePersonalEditMode = () => {
    if (personalEditMode) {
      // Reset validation errors when canceling
      const newErrors = { ...validationErrors };
      ['full_name', 'email_id', 'contact_number', 'location', 'occupation'].forEach(field => {
        delete newErrors[field];
      });
      setValidationErrors(newErrors);

      // Refetch profile data to reset changes
      if (userId) {
        fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`)
          .then(response => response.json())
          .then(data => {
            if (data.status === "SUCCESS") {
              setProfileData(data.result);
            }
          })
          .catch(err => {
            console.error('Error refetching profile:', err);
          });
      }
    }
    setPersonalEditMode(!personalEditMode);
  };

  const toggleProfessionalEditMode = () => {
    if (professionalEditMode) {
      // Reset validation errors when canceling
      const newErrors = { ...validationErrors };
      ['professional_title', 'company_name', 'years_of_experience', 'license_number', 'bio', 'website', 'linkedin', 'facebook'].forEach(field => {
        delete newErrors[field];
      });
      setValidationErrors(newErrors);

      // Refetch profile data to reset changes
      if (userId) {
        fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`)
          .then(response => response.json())
          .then(data => {
            if (data.status === "SUCCESS") {
              setProfileData(data.result);
            }
          })
          .catch(err => {
            console.error('Error refetching profile:', err);
          });
      }
    }
    setProfessionalEditMode(!professionalEditMode);
  };

  // Toggle photo edit mode
  const togglePhotoEditMode = () => {
    if (photoEditMode) {
      // Cancel: Reset to original photo
      setPreviewUrl(originalPhotoUrl);
      setSelectedFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
    setPhotoEditMode(!photoEditMode);
  };

  const handleFileChange = (event) => {
    // Get the first file from the FileList
    const file = event.target.files[0];
    if (file) {
      // Validate file size (5MB limit)
      if (file.size > 5 * 1024 * 1024) {
        showSnackbar('Profile image exceeds 5MB limit', 'error');
        return;
      }

      // Validate file type
      if (!file.type.match('image.*')) {
        showSnackbar('Please select a valid image for your profile', 'error');
        return;
      }

      setSelectedFile(file);
      // Create preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);

      // Clear input value to allow re-selecting the same file
      event.target.value = '';
    }
  };

  // Trigger file input click
  const handlePhotoButtonClick = () => {
    fileInputRef.current.click();
  };

  // Handle change password dialog
  const handleOpenChangePassword = () => {
    setChangePasswordOpen(true);
  };

  const handleCloseChangePassword = () => {
    setChangePasswordOpen(false);
  };

  // Validate all fields before saving
  const validateAllFields = () => {
    const errors = {};
    let isValid = true;

    // Only validate fields that have values (since fields are optional)
    Object.entries(profileData || {}).forEach(([key, value]) => {
      if (value && typeof value === 'string' && value.trim() !== '') {
        const error = validateField(key, value);
        if (error) {
          errors[key] = error;
          isValid = false;
        }
      }
    });

    setValidationErrors(errors);
    return isValid;
  };

  // ✅ Updated handleSavePhotoChanges with better error handling
  const handleSavePhotoChanges = async () => {
    if (!selectedFile) {
      showSnackbar('Please select a photo to upload', 'warning');
      return;
    }

    try {
      setSaving(true);
      const formData = new FormData();
      formData.append('user_id', userId);
      formData.append('full_name', profileData?.full_name || '');
      formData.append('email_id', profileData?.email_id || '');
      formData.append('contact_number', profileData?.contact_number || '');
      formData.append('location', profileData?.location || '');
      formData.append('occupation', profileData?.occupation || '');
      formData.append('professional_title', profileData?.professional_title || '');
      formData.append('company_name', profileData?.company_name || '');
      formData.append('years_of_experience', profileData?.years_of_experience || '');
      formData.append('license_number', profileData?.license_number || '');
      formData.append('bio', profileData?.bio || '');
      formData.append('website', profileData?.website || '');
      formData.append('linkedin', profileData?.linkedin || '');
      formData.append('facebook', profileData?.facebook || '');
      formData.append('profile_image', selectedFile);

      const response = await fetch('https://www.propertydealstalk.com/api/users/UpdateUserprofile', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === "SUCCESS") {
        showSnackbar('Profile photo updated successfully', 'success');
        setProfileData(data.result);
        
        if (data.result.profile_image) {
          setPreviewUrl(data.result.profile_image);
          setOriginalPhotoUrl(data.result.profile_image);
          
          // Update Redux state with new profile image
          const updatedUser = {
            ...user,
            profileImage: data.result.profile_image,
            fullName: data.result.full_name,
            email: data.result.email_id,
            contactNumber: data.result.contact_number,
            location: data.result.location,
            occupation: data.result.occupation,
            professionalTitle: data.result.professional_title,
            companyName: data.result.company_name,
            yearsOfExperience: data.result.years_of_experience,
            licenseNumber: data.result.license_number,
            bio: data.result.bio,
            website: data.result.website,
            linkedin: data.result.linkedin,
            facebook: data.result.facebook,
          };

          if (data.result.auth_provider === 'google') {
            dispatch(setGoogleUser(updatedUser));
          } else {
            dispatch(setUser(updatedUser));
          }
        }

        // ✅ Trigger navbar refresh
        localStorage.setItem('profile_updated', 'true');

        setPhotoEditMode(false);
        setSelectedFile(null);
      } else {
        // Show the actual error message from API
        showSnackbar(data.message || 'Failed to update profile photo. Please try again.', 'error');
      }
    } catch (err) {
      console.error('Error updating profile photo:', err);
      // Only show connection error for network failures
      const errorMessage = err.message.includes('fetch') || err.message.includes('network') 
        ? 'Unable to update profile photo. Please check your connection and try again.'
        : `Failed to update profile photo: ${err.message}`;
      showSnackbar(errorMessage, 'error');
    } finally {
      setSaving(false);
    }
  };

  // ✅ Updated handleSavePersonalChanges with better error handling
  const handleSavePersonalChanges = async () => {
    // Validate all fields before saving
    if (!validateAllFields()) {
      showSnackbar('Please correct the validation errors before saving', 'error');
      return;
    }

    try {
      setSaving(true);
      // Create FormData for file upload
      const formData = new FormData();

      // Add user_id
      formData.append('user_id', userId);

      // Add all required profile data fields to FormData
      formData.append('full_name', profileData?.full_name || '');
      formData.append('email_id', profileData?.email_id || '');
      formData.append('contact_number', profileData?.contact_number || '');
      formData.append('location', profileData?.location || '');
      formData.append('occupation', profileData?.occupation || '');
      formData.append('professional_title', profileData?.professional_title || '');
      formData.append('company_name', profileData?.company_name || '');
      formData.append('years_of_experience', profileData?.years_of_experience || '');
      formData.append('license_number', profileData?.license_number || '');
      formData.append('bio', profileData?.bio || '');
      formData.append('website', profileData?.website || '');
      formData.append('linkedin', profileData?.linkedin || '');
      formData.append('facebook', profileData?.facebook || '');

      // Add profile image if selected
      if (selectedFile) {
        formData.append('profile_image', selectedFile);
      }

      const response = await fetch('https://www.propertydealstalk.com/api/users/UpdateUserprofile', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const data = await response.json();
      console.log('Profile update response:', data);

      if (data.status === "SUCCESS") {
        showSnackbar('Profile updated successfully', 'success');
        // Update the profile data with the response result
        setProfileData(data.result);

        // Update preview URL if there's a profile image in the response
        if (data.result.profile_image) {
          setPreviewUrl(data.result.profile_image);
        }

        // Update Redux state
        const updatedUser = {
          ...user,
          fullName: data.result.full_name,
          email: data.result.email_id,
          contactNumber: data.result.contact_number,
          profileImage: data.result.profile_image,
          location: data.result.location,
          occupation: data.result.occupation,
        };

        if (data.result.auth_provider === 'google') {
          dispatch(setGoogleUser(updatedUser));
        } else {
          dispatch(setUser(updatedUser));
        }

        // ✅ Trigger navbar refresh
        localStorage.setItem('profile_updated', 'true');

        // Reset edit mode
        setPersonalEditMode(false);
        // Reset selected file after successful upload
        setSelectedFile(null);
        // Reset validation errors
        setValidationErrors({});
      } else {
        // Show the actual error message from API
        showSnackbar(data.message || 'Failed to update profile. Please try again.', 'error');
      }
    } catch (err) {
      console.error('Error updating profile:', err);
      // Only show connection error for network failures
      const errorMessage = err.message.includes('fetch') || err.message.includes('network') 
        ? 'Unable to update profile. Please check your connection and try again.'
        : `Failed to update profile: ${err.message}`;
      showSnackbar(errorMessage, 'error');
    } finally {
      setSaving(false);
    }
  };

  // ✅ Updated handleSaveProfessionalChanges with better error handling
  const handleSaveProfessionalChanges = async () => {
    // Validate all fields before saving
    if (!validateAllFields()) {
      showSnackbar('Please correct the validation errors before saving', 'error');
      return;
    }

    try {
      setSaving(true);
      // Create FormData for file upload
      const formData = new FormData();

      // Add user_id
      formData.append('user_id', userId);

      // Add all required profile data fields to FormData
      formData.append('full_name', profileData?.full_name || '');
      formData.append('email_id', profileData?.email_id || '');
      formData.append('contact_number', profileData?.contact_number || '');
      formData.append('location', profileData?.location || '');
      formData.append('occupation', profileData?.occupation || '');
      formData.append('professional_title', profileData?.professional_title || '');
      formData.append('company_name', profileData?.company_name || '');
      formData.append('years_of_experience', profileData?.years_of_experience || '');
      formData.append('license_number', profileData?.license_number || '');
      formData.append('bio', profileData?.bio || '');
      formData.append('website', profileData?.website || '');
      formData.append('linkedin', profileData?.linkedin || '');
      formData.append('facebook', profileData?.facebook || '');

      // Add profile image if selected
      if (selectedFile) {
        formData.append('profile_image', selectedFile);
      }

      const response = await fetch('https://www.propertydealstalk.com/api/users/UpdateUserprofile', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const data = await response.json();
      console.log('Profile update response:', data);

      if (data.status === "SUCCESS") {
        showSnackbar('Profile updated successfully', 'success');
        // Update the profile data with the response result
        setProfileData(data.result);

        // Update preview URL if there's a profile image in the response
        if (data.result.profile_image) {
          setPreviewUrl(data.result.profile_image);
        }

        // Update Redux state
        const updatedUser = {
          ...user,
          professionalTitle: data.result.professional_title,
          companyName: data.result.company_name,
          yearsOfExperience: data.result.years_of_experience,
          licenseNumber: data.result.license_number,
          bio: data.result.bio,
          website: data.result.website,
          linkedin: data.result.linkedin,
          facebook: data.result.facebook,
          profileImage: data.result.profile_image,
        };

        if (data.result.auth_provider === 'google') {
          dispatch(setGoogleUser(updatedUser));
        } else {
          dispatch(setUser(updatedUser));
        }

        // ✅ Trigger navbar refresh
        localStorage.setItem('profile_updated', 'true');

        // Reset edit mode
        setProfessionalEditMode(false);
        // Reset selected file after successful upload
        setSelectedFile(null);
        // Reset validation errors
        setValidationErrors({});
      } else {
        // Show the actual error message from API
        showSnackbar(data.message || 'Failed to update profile. Please try again.', 'error');
      }
    } catch (err) {
      console.error('Error updating profile:', err);
      // Only show connection error for network failures
      const errorMessage = err.message.includes('fetch') || err.message.includes('network') 
        ? 'Unable to update profile. Please check your connection and try again.'
        : `Failed to update profile: ${err.message}`;
      showSnackbar(errorMessage, 'error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  // ✅ Updated error display UI
  if (error) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '400px',
          p: 4,
          textAlign: 'center'
        }}
      >
        <Typography 
          sx={{ 
            color: '#666',
            fontSize: '1.1rem',
            fontWeight: 500,
            maxWidth: '600px'
          }}
        >
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        flex: 1,
        mt: { xs: '10px', md: '25px' },
        mr: { md: '80px' },
        mb: '20px',
        background: '#fff',
        p: { xs: '15px', md: '40px 50px' },
        borderRadius: '16px',
        width: { xs: 'calc(100% - 30px)', md: 'auto' },
        mx: { xs: 'auto', md: 0 }
      }}
    >
      {saving && <Loader />}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Typography
        variant="h2"
        sx={{
          fontSize: '24px',
          fontWeight: 600,
          mb: '4px',
        }}
      >
        Edit Profile
      </Typography>

      <Typography
        sx={{
          fontSize: '14px',
          color: '#555',
          mb: '24px',
        }}
      >
        Update your personal information and preferences
      </Typography>

      {/* Photo Section with Save/Cancel Buttons */}
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        mb: '40px',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: { xs: 'column', sm: 'row' } }}>
          {previewUrl || profileData?.profile_image ? (
            <Box
              component="img"
              src={previewUrl || profileData?.profile_image}
              alt="Profile"
              sx={{
                width: '100px',
                height: '100px',
                borderRadius: '50%',
                objectFit: 'cover',
                mb: { xs: 2, sm: 0 }
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
          ) : (
            <AccountCircleIcon
              sx={{
                width: '100px',
                height: '100px',
                color: '#9CA3AF',
                mb: { xs: 2, sm: 0 }
              }}
            />
          )}

          <Box sx={{
            ml: { xs: 0, sm: '20px' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', sm: 'flex-start' }
          }}>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={handleFileChange}
              disabled={!photoEditMode}
            />
            <Button
              variant="contained"
              onClick={handlePhotoButtonClick}
              disabled={saving || !photoEditMode}
              sx={{
                background: photoEditMode ? '#0066ff' : '#cccccc',
                color: '#fff',
                px: '12px',
                py: '6px',
                borderRadius: '6px',
                fontSize: '12px',
                display: 'block',
                '&:hover': { background: photoEditMode ? '#0055cc' : '#cccccc' },
                '&.Mui-disabled': {
                  background: '#cccccc',
                  color: '#666666',
                },
              }}
            >
              {saving ? 'Uploading...' : 'Change Photo'}
            </Button>
            <Typography
              sx={{
                fontSize: '12px',
                color: '#666',
                mt: '4px',
                textAlign: { xs: 'center', sm: 'left' }
              }}
            >
              JPG, PNG (max 5MB)
            </Typography>
          </Box>
        </Box>

        {/* Save/Cancel Buttons for Photo */}
        <Box sx={{ display: 'flex', gap: '12px', mt: { xs: 2, sm: 0 } }}>
          {photoEditMode && (
            <Button
              variant="contained"
              onClick={handleSavePhotoChanges}
              disabled={saving || !selectedFile}
              sx={{
                background: '#0066ff',
                color: '#fff',
                px: '12px',
                py: '6px',
                borderRadius: '6px',
                fontSize: '12px',
                '&:hover': { background: '#0055cc' },
                '&.Mui-disabled': {
                  background: '#cccccc',
                  color: '#666666',
                },
              }}
            >
              Save Changes
            </Button>
          )}
          <Button
            variant="contained"
            onClick={togglePhotoEditMode}
            sx={{
              background: '#0066ff',
              color: '#fff',
              px: '12px',
              py: '6px',
              borderRadius: '6px',
              fontSize: '12px',
              '&:hover': { background: '#0055cc' },
            }}
          >
            {photoEditMode ? 'Cancel' : 'Edit photo'}
          </Button>
        </Box>
      </Box>

      {/* PERSONAL INFORMATION */}
      <Box
        sx={{
          background: '#fff',
          p: { xs: '15px', md: '24px 20px' },
          borderRadius: '12px',
          mb: '30px',
          boxShadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
          ml: { md: '120px' },
          border: '1px solid #E5E7EB',
          width: { xs: '100%', md: 'auto' },
          boxSizing: 'border-box'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            mb: '20px',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2, sm: 0 }
          }}
        >
          <Typography sx={{ fontSize: '16px', m: 0 }}>Personal Information</Typography>
                      <Box sx={{ display: 'flex', gap: '12px' }}>
              {personalEditMode && (
                <Button
                  variant="contained"
                  onClick={handleSavePersonalChanges}
                  disabled={saving}
                  sx={{
                    background: '#0066ff',
                    color: '#fff',
                    px: '12px',
                    py: '6px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    '&:hover': { background: '#0055cc' },
                    '&.Mui-disabled': {
                      background: '#cccccc',
                      color: '#666666',
                    },
                  }}
                >
                  Save Changes
                </Button>
              )}
              <Button
                variant="contained"
                onClick={togglePersonalEditMode}
                sx={{
                  background: '#0066ff',
                  color: '#fff',
                  px: '12px',
                  py: '6px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  '&:hover': { background: '#0055cc' },
                }}
              >
                {personalEditMode ? 'Cancel' : 'Edit Details'}
              </Button>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <Box
              sx={{
                display: 'flex',
                gap: { xs: '15px', md: '70px' },
                flexDirection: { xs: 'column', md: 'row' },
              }}
            >
              <FormGroup
                label="Full Name"
                type="text"
                value={profileData?.full_name || ''}
                onChange={(e) => handleChange('full_name', e.target.value)}
                disabled={!personalEditMode}
                error={validationErrors.full_name}
              />
              <FormGroup
                label="Email"
                type="email"
                value={profileData?.email_id || ''}
                onChange={(e) => handleChange('email_id', e.target.value)}
                disabled={!personalEditMode}
                error={validationErrors.email_id}
              />
            </Box>

            <Box
              sx={{
                display: 'flex',
                gap: { xs: '15px', md: '70px' },
                flexDirection: { xs: 'column', md: 'row' },
              }}
            >
              <FormGroup
                label="Phone Number"
                type="text"
                value={profileData?.contact_number || ''}
                onChange={(e) => handleChange('contact_number', e.target.value)}
                disabled={!personalEditMode}
                error={validationErrors.contact_number}
              />
              <FormGroup
                label="Location"
                type="text"
                value={profileData?.location || ''}
                onChange={(e) => handleChange('location', e.target.value)}
                disabled={!personalEditMode}
                error={validationErrors.location}
              />
            </Box>

            <Box
              sx={{
                display: 'flex',
                gap: { xs: '15px', md: '70px' },
                flexDirection: { xs: 'column', md: 'row' },
              }}
            >
              <FormGroup
                label="Occupation"
                type="text"
                value={profileData?.occupation || ''}
                onChange={(e) => handleChange('occupation', e.target.value)}
                disabled={!personalEditMode}
                error={validationErrors.occupation}
              />
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                maxWidth: 'none',
                width: '100%',
              }}
            >
              <Typography sx={{ fontSize: '12px', mb: '6px', color: '#333' }}>
                Password
              </Typography>
              <Box
                sx={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  width: { xs: '100%', md: '45%' },
                }}
              >
                <TextField
                  type="password"
                  size="small"
                  fullWidth
                  disabled={!personalEditMode}
                  value="********"
                  sx={{
                    '& input': {
                      p: '10px 12px',
                      backgroundColor: '#F9FAFB',
                    },
                    '& fieldset': {
                      borderRadius: '6px',
                      borderColor: '#ddd',
                    },
                  }}
                />
                <Button
                  sx={{
                    position: 'absolute',
                    right: '10px',
                    background: 'transparent',
                    color: '#0066ff',
                    fontSize: '12px',
                    minWidth: 'auto',
                    p: 0,
                    '&:hover': { background: 'transparent' },
                  }}
                  disabled={!personalEditMode}
                  onClick={handleOpenChangePassword}
                >
                  Change
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* PROFESSIONAL INFORMATION */}
        <Box
          sx={{
            background: '#fff',
            p: { xs: '15px', md: '24px 20px' },
            borderRadius: '12px',
            mb: '30px',
            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
            ml: { md: '120px' },
            border: '1px solid #E5E7EB',
            width: { xs: '100%', md: 'auto' },
            boxSizing: 'border-box'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: { xs: 'flex-start', sm: 'center' },
              flexDirection: { xs: 'column', sm: 'row' },
              mb: '20px',
              gap: { xs: 2, sm: 0 }
            }}
          >
            <Typography sx={{ fontSize: '16px', m: 0 }}>Professional Information</Typography>
            <Box sx={{ display: 'flex', gap: '12px' }}>
              {professionalEditMode && (
                <Button
                  variant="contained"
                  onClick={handleSaveProfessionalChanges}
                  disabled={saving}
                  sx={{
                    background: '#0066ff',
                    color: '#fff',
                    px: '12px',
                    py: '6px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    '&:hover': { background: '#0055cc' },
                    '&.Mui-disabled': {
                      background: '#cccccc',
                      color: '#666666',
                    },
                  }}
                >
                  Save Changes
                </Button>
              )}
              <Button
                variant="contained"
                onClick={toggleProfessionalEditMode}
                sx={{
                  background: '#0066ff',
                  color: '#fff',
                  px: '12px',
                  py: '6px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  '&:hover': { background: '#0055cc' },
                }}
              >
                {professionalEditMode ? 'Cancel' : 'Edit Details'}
              </Button>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <Box
              sx={{
                display: 'flex',
                gap: { xs: '15px', md: '70px' },
                flexDirection: { xs: 'column', md: 'row' },
              }}
            >
              <FormGroup
                label="Professional Title"
                type="text"
                value={profileData?.professional_title || ''}
                onChange={(e) => handleChange('professional_title', e.target.value)}
                disabled={!professionalEditMode}
                error={validationErrors.professional_title}
              />
              <FormGroup
                label="Company Name"
                type="text"
                value={profileData?.company_name || ''}
                onChange={(e) => handleChange('company_name', e.target.value)}
                disabled={!professionalEditMode}
                error={validationErrors.company_name}
              />
            </Box>

            <Box
              sx={{
                display: 'flex',
                gap: { xs: '15px', md: '70px' },
                flexDirection: { xs: 'column', md: 'row' },
              }}
            >
              <FormGroup
                label="Years of Experience"
                type="text"
                value={profileData?.years_of_experience || ''}
                onChange={(e) => handleChange('years_of_experience', e.target.value)}
                disabled={!professionalEditMode}
                error={validationErrors.years_of_experience}
              />
              <FormGroup
                label="License Number"
                type="text"
                value={profileData?.license_number || ''}
                onChange={(e) => handleChange('license_number', e.target.value)}
                disabled={!professionalEditMode}
                error={validationErrors.license_number}
              />
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <Typography sx={{ fontSize: '12px', mb: '6px', color: '#333' }}>
                Bio
              </Typography>
              <TextareaAutosize
                minRows={4}
                value={profileData?.bio || ''}
                onChange={(e) => handleChange('bio', e.target.value)}
                disabled={!professionalEditMode}
                style={{
                  padding: '10px 12px',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  fontSize: '14px',
                  width: '95%',
                  backgroundColor: professionalEditMode ? '#F9FAFB' : '#f5f5f5',
                }}
              />
              {validationErrors.bio && (
                <Typography color="error" sx={{ fontSize: '11px', mt: '4px' }}>
                  {validationErrors.bio}
                </Typography>
              )}
            </Box>

            <FormGroup
              label="Website"
              type="text"
              value={profileData?.website || ''}
              onChange={(e) => handleChange('website', e.target.value)}
              fullWidth
              disabled={!professionalEditMode}
              error={validationErrors.website}
            />

            <Box
              sx={{
                display: 'flex',
                gap: { xs: '15px', md: '70px' },
                flexDirection: { xs: 'column', md: 'row' },
              }}
            >
              <FormGroup
                label="LinkedIn"
                type="text"
                value={profileData?.linkedin || ''}
                onChange={(e) => handleChange('linkedin', e.target.value)}
                disabled={!professionalEditMode}
                error={validationErrors.linkedin}
              />
              <FormGroup
                label="Facebook"
                type="text"
                value={profileData?.facebook || ''}
                onChange={(e) => handleChange('facebook', e.target.value)}
                disabled={!professionalEditMode}
                error={validationErrors.facebook}
              />
            </Box>
          </Box>
        </Box>

        {/* Change Password Dialog */}
        <ChangePassword
          open={changePasswordOpen}
          onClose={handleCloseChangePassword}
        />
      </Box>
    );
  };

  // FormGroup component to handle value and onChange with error display
  const FormGroup = ({ label, type, fullWidth = false, value, onChange, disabled = false, error }) => (
    <Box sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      maxWidth: fullWidth ? 'none' : { xs: 'none', md: '350px' },
      width: fullWidth ? '100%' : 'auto'
    }}>
      <Typography sx={{ fontSize: '12px', mb: '6px', color: '#333' }}>
        {label}
      </Typography>
      <TextField
        type={type}
        size="small"
        fullWidth
        value={value}
        onChange={onChange}
        disabled={disabled}
        error={Boolean(error)}
        sx={{
          '& input': {
            p: '10px 12px',
            backgroundColor: disabled ? '#f5f5f5' : '#F9FAFB',
          },
          '& fieldset': {
            borderRadius: '6px',
            borderColor: error ? 'red' : '#ddd',
          },
        }}
      />
      {error && (
        <Typography color="error" sx={{ fontSize: '11px', mt: '4px' }}>
          {error}
        </Typography>
      )}
    </Box>
  );

  export default ProfileEdit;
